// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__3pBFB","inputWrap":"styles_inputWrap__3ny9w","input":"styles_input__1wKQO"};